module.exports = __webpack_public_path__ + "img/15-1_02.e3291596.jpg";